import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("nl");

  const toggle = useCallback(
    () => setLang((prev) => (prev === "nl" ? "tr" : "nl")),
    [],
  );

  const setLanguage = useCallback((next) => setLang(next), []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
